import {useEffect} from 'react';
import FontSelector from '../Editor/FontSelector';
import OwnColor from '../Editor/OwnColor';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import ActionList from '../Editor/ActionList';
import MusicList from '../Editor/MusicList';
import RowOfIcons from './RowOfIcons';
import DoGuide from './DoGuide';

function App(props) {

  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var detailsWidth = props.detailsWidth;
  var error = props.error;
  var addToExtraScreen = props.addToExtraScreen;
  var mostRecentFont = props.mostRecentFont;
  var setMostRecentFont = props.setMostRecentFont;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var changeTab = props.changeTab;
  var tabSelected = props.tabSelected;
  var userNos = props.userNos;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;
  var chains = props.chains;

  var selectTab = tabSelected.s;

  useEffect(()=>{
    if (!currentList.s){
      var changes = [{t:'w',w:['s'],n:{}}];
      organicChanges(changes);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  var contents;
  var styles = {};
  if (currentList.s){
    styles = currentList.s;
  }

  function submitGeneric(val, pointer){
    var changes = [{t:'w', w:['s', pointer], n:val}];
    organicChanges(changes);
  }

  var selectedText = '';
  if (selectTab === 0){
    selectedText = 'Font'
    var origFont = ResponsiveFns.getOrigFn('fontFamily', styles);
    function clickFontFamily1(g){
      submitGeneric({t:'font', v:g}, 'fontFamily');
    }
    contents = <FontSelector clickFontFamily={clickFontFamily1} currentFont={origFont} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont}/>
  }else if (selectTab === 1 || selectTab === 2){

    var tgt = 'color';
    if (selectTab === 2){
      selectedText = 'Background Color'
      tgt = 'backgroundColor';
    }else{
      selectedText = 'Color';
    }
    var currentColor = null;
    if (styles[tgt]){
      currentColor = styles[tgt];
    }

    function clickColor(g){
      if (g){
        submitGeneric({t:'raw', v:g}, tgt);
      }else{
        var changes = [{t:'r',w:['s'],i:tgt}];
        organicChanges(changes);
      }      
    }

    contents = <OwnColor currentList={currentList} submitColor={clickColor} currentStyle={currentColor} allowFormula={false} e={false} width={detailsWidth - 40} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} colorType={tgt} logPath={['s']} organicChanges={organicChanges} styles={styles}/>
  }else if (selectTab === 3){
    selectedText = 'Music';
    contents = <MusicList currentList={currentList} error={error} organicChanges={organicChanges} addToExtraScreen={addToExtraScreen} userNos={userNos} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />

  }else if (selectTab === 4){
    selectedText = 'Actions on Start';
    var path = ['oc', 'load'];
    contents = <ActionList chains={chains} width={detailsWidth - 40} startPath={path} currentList={currentList} error={error} organicChanges={organicChanges} changeTab={changeTab} addToExtraScreen={addToExtraScreen} userNos={userNos} doingWhat={doingWhat} setDoingWhat={setDoingWhat} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />

  }

  var actionError = false;
  if (error && error.loc){
    if (error.loc[0] === 'oc'){
      actionError = true;
    }
  }

  var options = [{i:'bx:font-family', n:'Font'}, {i:'eva:color-picker-fill', n:'Color'}, {i:'fluent:color-background-20-filled', n:'Background Color'}, {i:'ic:baseline-music-note', n:'Music'}, {i:'fa-solid:hourglass-start', n:'Actions On Start', e:actionError}];


  var icons = <RowOfIcons changeTab={changeTab} tabSelected={tabSelected} options={options}/>

   return <div className='container' ><center><br/>
              <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabOverallStyles'}} />
              <br/>
            {icons}
            <br/>
            <p className='lead mb-0' style={{color:'white', fontWeight:700}} >{selectedText}</p><br/>
            {contents}
   </center></div>

}

export default App;
